// Translation data extracted from LanguageProvider
export const translations = {
  ar: {
    nav: {
      indicators: "المؤشرات الرئيسية",
      management: "الإدارة",
      operations: "تشغيل الأعمال",
      agentManagement: "إدارة مندوبي المبيعات",
      dashboard: "لوحة التحكم",
      findLeads: "البحث عن العملاء",
      leadReport: "تقرير العميل",
      savedLeads: "العملاء المحفوظون",
      manageWhatsApp: "إدارة الواتساب",
      whatsappAnalysis: "تحليل الواتساب",
      workspaces: "مساحات العمل",
      allLeads: "جميع العملاء",
      teamLeads: "عملاء الفريق",
      staff: "فريق العمل",
      settings: "الإعدادات",
      knowledge: "قاعدة المعرفة",
      training: "تدريب المساعد",
      aiCenter: "إعدادات المساعد",
      outcomes: "نتائج العملاء",
      whatsapp: "محادثات الواتساب",
      centralBrain: "العقل الاستراتيجي",
      analytics: "التحليلات والتقارير",
      content: "المحتوى",
      ads: "الإعلانات",
      businessDeveloper: "مطور الأعمال",
      mockChat: "محادثة وهمية",
    },
    role: {
      ADMIN: "مدير",
      MANAGER: "مدير فريق المبيعات",
      AGENT: "مندوب مبيعات",
      CLIENT: "عميل",
    },
    language: {
      label: "اللغة",
      english: "English",
      arabic: "العربية",
    },
    sidebar: {
      switchHint: "غيّر لغة العرض",
      logout: "تسجيل الخروج",
    },
    dashboard: {
      activeAi: "الذكاء الاصطناعي يعمل بكفاءة",
      welcome: "مرحباً بك في لوحة التحكم",
      dashboardDesc: "مركز إدارة المساعد الذكي ولوحة تفاعلاتك المباشرة.",
      dailyUsage: "عدد الرسائل اليومي",
      agentActivity: "نشاط المساعد الذكي",
      knowledgeBase: "قاعدة معرفة العملاء",
      whatsappStatus: "حالة قناة الواتساب",
      totalReplies: "إجمالي ردود الذكاء الاصطناعي",
      knowledgeSources: "مصادر المعلومات للمساعد",
      manageFiles: "إدارة الملفات",
      channelConnected: "القناة متصلة",
      channelDisconnected: "القناة غير متصلة",
      connectedDesc: "يتم استقبال رسائل العملاء فوراً",
      disconnectedDesc: "يرجى مسح رمز QR لربط الواتساب",
      stableSession: "جلسة مستقرة",
      fixProblem: "حل المشكلة",
      allGood: "النظام يعمل بكفاءة تامة",
      commandCenter: "مركز القيادة",
      manageChannels: "إدارة القنوات",
      knowledgeTraining: "تدريب المعرفة",
      behaviorSetup: "إعداد السلوك",
      subscriptionStatus: "حالة الاشتراك",
      noLogs: "لا توجد ردود مسجلة حتى الآن",
    },
    whatsapp: {
        header: "واتساب بليكسا (Plexa)",
        emptyState: "اختر محادثة من القائمة للبدء. سيقوم الذكاء الاصطناعي بالرد تلقائيًا نيابةً عنك.",
        qrError: "حدث خطأ أثناء تحميل رمز الاستجابة السريعة (QR)",
        qrSteps: "يرجى مسح رمز الاستجابة السريعة باستخدام تطبيق واتساب على هاتفك.",
        qrButton: "إعادة تحميل الرمز",
        sidebarSearch: "ابحث في المحادثات...",
        sidebarEmpty: "لا توجد محادثات متاحة",
        timeFormat: "HH:mm",
        customerLabel: "عميل واتساب",
        loading: "يتم التحميل...",
        noMessages: "أرسل رسالة أو انتظر رسائل من العميل للبدء.",
        loadMore: "↑ اسحب للأعلى لتحميل رسائل أقدم",
        voiceMessage: "رسالة صوتية 🎙️",
        image: "صورة 🖼️",
        video: "فيديو 📹",
        attachedDoc: "مستند مرفق",
        typeMessage: "اكتب رسالتك هنا...",
    },
    leads: {
      generate: {
          title: "توليد العملاء المحتملين",
          subtitle: "استفد من الذكاء الاصطناعي لاكتشاف أفضل الفرص التجارية",
          locationLabel: "الموقع الجغرافي",
          locationPlaceholder: "مثال: الرياض، دبي، أو أي مدينة عربية",
          countLabel: "عدد العملاء المطلوب",
          industriesLabel: "القطاعات المستهدفة",
          selectedCount: "تم الاختيار",
          industriesPlaceholder: "اختر القطاعات المستهدفة...",
          servicesLabel: "الخدمات المقدمة",
          servicesPlaceholder: "اختر الخدمات التي ترغب في تقديمها...",
          keywordsLabel: "كلمات مفتاحية إضافية (اختياري)",
          keywordsPlaceholder: "مثال: شركات ناشئة، مشاريع صغيرة، بحاجة لإعادة تصميم...",
          instructionsLabel: "أوامر مخصصة (اختياري)",
          instructionsPlaceholder: "اكتب تعليمات مخصصة لتحسين البحث، مثل: استهدف الشركات التي تبحث عن حلول تسويق رقمي متكاملة...",
          generateButton: "ابدأ توليد العملاء الآن",
          generatingButton: "يعمل الذكاء الاصطناعي على البحث عن أفضل الفرص...",
          resultsTitle: "نتائج البحث",
          resultsCount: "عميل محتمل",
          errorSelectIndustry: "يرجى اختيار قطاع واحد على الأقل",
          errorSelectService: "يرجى اختيار خدمة واحدة على الأقل",
          errorGeneration: "حدث خطأ أثناء توليد العملاء",
          errorConnection: "تعذر الاتصال. يرجى التأكد من اتصال الإنترنت.",
          successMessage: "تم توليد {count} عميل محتمل بنجاح! 🎉",
          progressMessages: [
            "يتم إنشاء استعلامات بحث ذكية...",
            "الذكاء الاصطناعي يحلل الأسواق...",
            "تقييم فرص النجاح لكل شركة...",
            "كتابة التحليلات والرسائل باللغة العربية...",
            "ترتيب العملاء حسب الأولوية...",
          ],
          successProgress: "✅ تم توليد العملاء بنجاح!",
          industries: [
            "صالونات تجميل",
            "مستشفيات ومراكز طبية",
            "شركات عقارية",
            "مطاعم وكافيهات",
            "مدارس ومراكز تعليمية",
            "مكاتب محاماة",
            "وكالات سفر وسياحة",
            "معارض سيارات",
            "شركات مقاولات",
            "محلات تجارية",
            "نوادي رياضية",
            "شركات تقنية وبرمجيات",
            "خدمات مالية ومحاسبة",
            "شركات تأمين",
            "شركات أغذية ومشروبات",
            "محلات ملابس وأزياء",
            "محلات أثاث وديكور",
            "مزارع وخدمات زراعية",
            "شركات طاقة وبيئة",
            "متاجر إلكترونية",
          ],
          services: [
            "تحسين محركات البحث (SEO)",
            "إعلانات جوجل (Google Ads)",
            "التسويق عبر وسائل التواصل الاجتماعي",
            "إعلانات فيسبوك وإنستغرام",
            "إعلانات تيك توك",
            "تصميم وتطوير المواقع الإلكترونية",
            "تسويق المحتوى",
            "التسويق عبر البريد الإلكتروني",
            "إنتاج الفيديو",
            "بناء العلامة التجارية والهوية",
            "التسويق بالأداء",
            "إدارة السمعة الرقمية",
          ],
        },
      },
    leadReport: {
        title: "تقرير ذكاء العملاء",
        subtitle: "أدخل معلومات أساسية عن العمل لتوليد تقرير استخبارات تجارية ذكي.",
        defaultService: "ذكاء العميل",
        analyzeButton: "توليد التقرير",
        analyzing: "يتم إنشاء التقرير...",
        resultsTitle: "نتائج التقرير",
        resultsSubtitle: "تحليل ذكي مبني على البيانات المتاحة.",
        fields: {
          companyName: "اسم الشركة",
          industry: "القطاع",
          website: "الموقع الإلكتروني",
          phone: "الهاتف",
          email: "البريد الإلكتروني",
          facebookUrl: "رابط فيسبوك",
          instagramUrl: "رابط إنستغرام",
          linkedinUrl: "رابط لينكدإن",
          twitterUrl: "رابط تويتر",
          tiktokUrl: "رابط تيك توك",
          notes: "ملاحظات إضافية",
        },
        placeholders: {
          companyName: "مثال: الشركة الوطنية للعقارات",
          industry: "مثال: التسويق الرقمي أو تجارة التجزئة",
          website: "https://example.com",
          phone: "+966 5 1234 5678",
          email: "info@example.com",
          facebookUrl: "https://facebook.com/example",
          instagramUrl: "https://instagram.com/example",
          linkedinUrl: "https://linkedin.com/company/example",
          twitterUrl: "https://twitter.com/example",
          tiktokUrl: "https://tiktok.com/@example",
          notes: "أدخل أي سياق إضافي عن النشاط التجاري أو الأهداف...",
        },
        errorAtLeastOne: "يرجى إدخال معلومة واحدة على الأقل.",
        resultsFields: {
          companyOverview: "نظرة عامة على الشركة",
          websiteAnalysis: "تحليل الموقع والحضور الرقمي",
          seoAnalysis: "تحليل تحسين محركات البحث",
          adsAnalysis: "تحليل الإعلانات",
          adsActivityTimeline: "جدول نشاط الإعلانات",
          competitorAdsActivity: "نشاط إعلانات المنافسين",
          techAudit: "أهم ملاحظات التدقيق التقني",
          summary: "الملخص والتوصيات",
        },
    },
    admin: {
      allLeads: {
          title: "كل العملاء",
          subtitle: "استعرض وادِر جميع عملاء الفريق بسهولة",
          leadsCount: "عملاء",
          exportCsv: "تصدير كملف CSV",
          searchPlaceholder: "ابحث باسم الشركة أو القطاع...",
          allStatuses: "جميع الحالات",
          allAgents: "جميع أعضاء الفريق",
          noResults: "لا توجد نتائج مطابقة",
          tableHeaders: {
            company: "اسم الشركة",
            industry: "القطاع",
            priority: "الأولوية",
            successChance: "فرصة النجاح",
            status: "الحالة",
            agent: "المندوب",
            date: "تاريخ الإضافة",
            view: "عرض التفاصيل",
          },
          statusLabels: {
            NEW: "جديد",
            CONTACTED: "تم التواصل",
            QUALIFIED: "مؤهل",
            WON: "تمت الصفقة",
            LOST: "مستبعد",
          },
          priorityLabels: {
            HIGH: "مرتفعة",
            MEDIUM: "متوسطة",
            LOW: "منخفضة",
          },
          unassigned: "غير معين",
          view: "عرض التفاصيل",
          exportSuccess: "✅ تم تصدير العملاء بنجاح!",
          errorLoad: "تعذر تحميل العملاء أو المندوبين",
          errorAssign: "تعذر تعيين المندوب",
          successAssign: "تم تحديث تعيين المندوب بنجاح",
          csvHeaders: [
            "اسم الشركة",
            "القطاع",
            "الموقع",
            "الهاتف",
            "البريد الإلكتروني",
            "الموقع الإلكتروني",
            "Facebook",
            "Instagram",
            "TikTok",
            "Twitter",
            "LinkedIn",
            "الأولوية",
            "فرصة النجاح",
            "الحالة",
            "المندوب",
            "تاريخ الإضافة",
          ],
      },
      agents: {
          title: "إدارة المستخدمين",
          subtitle: "أنشئ وادِر حسابات المستخدمين",
          addAgent: "إضافة مستخدم جديد",
          noAgents: "لا يوجد مستخدمون حتى الآن",
          noAgentsDesc: "أضف أعضاء جدد إلى الفريق",
          addAgentBtn: "إضافة مستخدم",
          tableHeaders: {
            name: "الاسم الكامل",
            username: "اسم المستخدم",
            role: "الدور",
            status: "الحالة",
            leadsCount: "عدد العملاء",
            createdDate: "تاريخ الإنشاء",
            actions: "الإجراءات",
          },
          roles: {
            ADMIN: "مدير",
            MANAGER: "مدير فريق المبيعات",
            AGENT: "مندوب",
          },
          status: {
            active: "نشط",
            inactive: "غير نشط",
          },
          buttons: {
            edit: "تعديل",
            delete: "حذف",
            saving: "جارٍ الحفظ...",
            save: "حفظ",
            cancel: "إلغاء",
          },
          modalTitles: {
            add: "إضافة مستخدم جديد",
            edit: "تعديل بيانات المستخدم",
          },
          formLabels: {
            fullName: "الاسم الكامل",
            username: "اسم المستخدم",
            password: "كلمة المرور",
            passwordHint: "(اتركها فارغة إذا لم ترغب في التغيير)",
          },
          placeholders: {
            fullName: "أحمد محمد",
            username: "ahmed_mohammed",
            password: "••••••••",
          },
          messages: {
            errorLoad: "تعذر تحميل المستخدمين",
            errorSave: "تعذر حفظ البيانات",
            successUpdate: "تم تحديث بيانات المستخدم",
            successCreate: "تم إنشاء المستخدم بنجاح",
            errorGeneric: "حدث خطأ غير متوقع",
            successDelete: "تم حذف المستخدم",
            errorDelete: "تعذر حذف المستخدم",
            errorStatus: "تعذر تحديث الحالة",
            confirmDelete: "هل أنت متأكد من حذف هذا المستخدم؟",
          },
      },
      workspaces: {
          searchPlaceholder: "ابحث في مساحات العمل...",
          totalWorkspaces: "إجمالي المساحات",
          newWorkspace: "مساحة عمل جديدة",
          activeWorkspace: "مساحة نشطة",
          statusActive: "نشطة",
          statusPaused: "متوقفة مؤقتًا",
          noDescription: "لا توجد تفاصيل إضافية لهذه المساحة حاليًا.",
          leadsCount: "عدد العملاء المحتملين",
          dailyLimit: "الحد اليومي للرسائل",
          viewDetails: "عرض تفاصيل المساحة",
          editSettings: "الإعدادات",
          pauseWorkspace: "إيقاف مؤقت",
          activateWorkspace: "تنشيط",
          modalTitleNew: "إضافة مساحة عمل جديدة",
          modalTitleEdit: "تعديل بيانات المساحة",
          modalSubtitle: "إدارة الأعمال",
          tabGeneral: "عام",
          tabClient: "حساب العميل",
          tabSettings: "الإعدادات",
          businessName: "الاسم التجاري",
          businessNamePlaceholder: "مثال: شركة عقارات - فرع الرياض",
          businessDescription: "وصف النشاط",
          businessDescriptionPlaceholder: "اشرح نشاط العميل والخدمات المقدمة...",
          businessGoal: "الهدف التجاري",
          businessGoalPlaceholder: "مثال: تحويل العملاء إلى مبيعات",
          tone: "نبرة التواصل",
          tonePlaceholder: "مثال: رسمي، ودود، عملي",
          clientDataDescription: "بيانات الدخول الأولية لحساب العميل في هذه المساحة.",
          clientName: "اسم العميل",
          clientNamePlaceholder: "مثال: أحمد السالمي",
          clientUsername: "اسم المستخدم",
          clientUsernamePlaceholder: "مثال: ahmed.salmi",
          clientPassword: "كلمة المرور المؤقتة",
          clientPasswordPlaceholder: "••••••••",
          clientEditNote: "لتعديل بيانات الدخول لاحقًا، استخدم لوحة تحكم العميل لهذه المساحة.",
          adminAccountTitle: "حساب المدير",
          adminUsername: "اسم مستخدم المدير",
          adminUsernamePlaceholder: "مثال: admin_username",
          adminPassword: "كلمة مرور المدير",
          adminPasswordPlaceholder: "••••••••",
          agentAccountTitle: "حساب المندوب",
          agentUsername: "اسم مستخدم المندوب",
          agentUsernamePlaceholder: "مثال: agent_username",
          agentPassword: "كلمة مرور المندوب",
          agentPasswordPlaceholder: "••••••••",
          dailyLimitLabel: "الحد اليومي للرسائل",
          brandingColor: "لون العلامة التجارية",
          cancel: "إلغاء",
          saveChanges: "حفظ التعديلات",
          createWorkspace: "إنشاء المساحة الآن",
          successUpdate: "تم تحديث البيانات بنجاح",
          successCreate: "تم إنشاء المساحة بنجاح",
          errorSave: "حدث خطأ أثناء حفظ البيانات",
          successActivate: "تم تفعيل المساحة",
          successPause: "تم إيقاف المساحة مؤقتًا",
          errorStatus: "تعذر تحديث الحالة",
      },
      whatsapp: {
          title: "إدارة قنوات واتساب",
          subtitle: "إدارة قنوات ومحادثات واتساب",
          loading: "جاري تهيئة لوحة الإدارة...",
          connecting: "جاري تهيئة الاتصال...",
          connectionFailed: "تعذر الاتصال — يرجى التأكد من تشغيل الخادم",
          disconnectConfirm: "سيؤدي قطع الاتصال بالقناة إلى إيقاف استقبال الرسائل فورًا. هل أنت متأكد؟",
          disconnected: "غير متصل",
          syncing: "جاري المزامنة...",
          syncSuccess: "تمت المزامنة!",
          syncFailed: "فشلت المزامنة",
          assignSuccess: "تم التعيين بنجاح",
          assignFailed: "تعذر التعيين",
          logoutSuccess: "تم قطع الاتصال بنجاح",
          logoutFailed: "حدث خطأ أثناء قطع الاتصال",
          status: {
            CONNECTED: "متصل",
            CONNECTING: "جاري الاتصال...",
            DISCONNECTED: "غير متصل",
            QR_READY: "رمز QR جاهز",
          },
          qrInstructions: "امسح الرمز باستخدام تطبيق واتساب",
          qrNote: "سينتهي صلاحية رمز QR خلال 45 ثانية",
          chats: "المحادثات",
          unassigned: "غير معين",
          conversation: "المحادثة",
          unread: "غير مقروء",
          metrics: {
            totalChats: "إجمالي المحادثات",
            activeChats: "المحادثات النشطة",
            unassignedChats: "المحادثات غير المعينة",
            totalMessages: "إجمالي الرسائل",
          },
          buttons: {
            connect: "اتصال",
            disconnect: "قطع الاتصال",
            sync: "مزامنة",
            refresh: "تحديث",
          },
          noChats: "لا توجد محادثات حتى الآن",
          noChatsDesc: "ستظهر المحادثات هنا عند استقبال رسائل من العملاء",
          selectChat: "اختر محادثة لعرض الرسائل",
          assignTo: "تعيين إلى",
          assign: "تعيين",
          noAgents: "لا يوجد مندوبون متاحون",
          errorLoad: "تعذر تحميل البيانات",
          errorConnection: "خطأ في الاتصال",
      },
    },
  },
  en: {
    nav: {
      indicators: "Indicators",
      management: "Management",
      operations: "Operations",
      agentManagement: "Agent Management",
      dashboard: "Dashboard",
      findLeads: "Find Leads",
      savedLeads: "Saved Leads",
      manageWhatsApp: "WhatsApp",
      whatsappAnalysis: "WhatsApp analysis",
      workspaces: "Workspaces",
      allLeads: "All Leads",
      teamLeads: "Team Leads",
      staff: "Team",
      settings: "Settings",
      knowledge: "Assistant Knowledge",
      training: "Training",
      aiCenter: "AI Center",
      outcomes: "Client Outcomes",
      whatsapp: "WhatsApp Chats",
      centralBrain: "Central Brain",
      analytics: "Analytics & Reports",
      content: "Content",
      ads: "Ads",
      businessDeveloper: "Your Business Developer",
      mockChat: "Mock Chat",
      leadReport: "Lead Report",
    },
    role: {
      ADMIN: "Admin",
      MANAGER: "Sales Manager",
      AGENT: "Sales Agent",
      CLIENT: "Client",
    },
    language: {
      label: "Language",
      english: "English",
      arabic: "Arabic",
    },
    sidebar: {
      switchHint: "Choose interface language",
      logout: "Sign Out",
    },
    dashboard: {
      activeAi: "AI is active and stable",
      welcome: "Welcome to",
      dashboardDesc: "Your smart assistant command center and live interaction dashboard.",
      dailyUsage: "Daily message usage",
      agentActivity: "Smart agent activity",
      knowledgeBase: "Client knowledge base",
      whatsappStatus: "WhatsApp channel status",
      totalReplies: "Total AI replies",
      knowledgeSources: "Information powering the assistant",
      manageFiles: "Manage files",
      channelConnected: "Connected",
      channelDisconnected: "Disconnected",
      connectedDesc: "Customer messages are received live",
      disconnectedDesc: "Scan the QR code to connect WhatsApp",
      stableSession: "Stable session",
      fixProblem: "Fix Issue",
      allGood: "Running efficiently",
      commandCenter: "Command & Launch Center",
      manageChannels: "Manage channels",
      knowledgeTraining: "Knowledge & training",
      behaviorSetup: "Behavior setup",
      subscriptionStatus: "Subscription status",
      noLogs: "No logged replies yet",
    },
    leadReport: {
      title: "Lead Intelligence Report",
      subtitle: "Enter basic business details to generate a smart intelligence report.",
      defaultService: "lead intelligence",
      analyzeButton: "Generate Report",
      analyzing: "Generating report...",
      resultsTitle: "Report Results",
      resultsSubtitle: "AI analysis based on the information you provided.",
      fields: {
        companyName: "Company Name",
        industry: "Industry",
        website: "Website",
        phone: "Phone",
        email: "Email",
        facebookUrl: "Facebook URL",
        instagramUrl: "Instagram URL",
        linkedinUrl: "LinkedIn URL",
        twitterUrl: "Twitter URL",
        tiktokUrl: "TikTok URL",
        notes: "Additional Notes",
      },
      placeholders: {
        companyName: "Example: Millennium Real Estate",
        industry: "Example: Digital Marketing or Retail",
        website: "https://example.com",
        phone: "+966 5 1234 5678",
        email: "info@example.com",
        facebookUrl: "https://facebook.com/example",
        instagramUrl: "https://instagram.com/example",
        linkedinUrl: "https://linkedin.com/company/example",
        twitterUrl: "https://twitter.com/example",
        tiktokUrl: "https://tiktok.com/@example",
        notes: "Provide any additional business context or goals...",
      },
      errorAtLeastOne: "Please provide at least one piece of business or digital information.",
      resultsFields: {
        companyOverview: "Company Overview",
        websiteAnalysis: "Website & Digital Presence",
        seoAnalysis: "SEO Analysis",
        adsAnalysis: "Ad Performance Analysis",
        adsActivityTimeline: "Ads Activity Timeline",
        competitorAdsActivity: "Competitor Ads Activity",
        techAudit: "Technical Audit Highlights",
        summary: "Summary & Recommendations",
      },
    },
    admin: {
      allLeads: {
        title: "All Leads",
        subtitle: "View and manage all team leads",
        leadsCount: "leads",
        exportCsv: "Export CSV",
        searchPlaceholder: "Search by company name or industry...",
        allStatuses: "All Statuses",
        allAgents: "All team members",
        noResults: "No results found",
        tableHeaders: {
          company: "Company",
          industry: "Industry",
          priority: "Priority",
          successChance: "Success Chance",
          status: "Status",
          agent: "Agent",
          date: "Date",
          view: "View",
        },
        statusLabels: {
          NEW: "New",
          CONTACTED: "Contacted",
          QUALIFIED: "Qualified",
          WON: "Won",
          LOST: "Lost",
        },
        priorityLabels: {
          HIGH: "High",
          MEDIUM: "Medium",
          LOW: "Low",
        },
        unassigned: "Unassigned",
        view: "View",
        exportSuccess: "✅ Leads exported successfully!",
        errorLoad: "Failed to load leads or agents",
        errorAssign: "Failed to assign agent",
        successAssign: "Agent assignment updated successfully",
        csvHeaders: [
          "Company",
          "Industry",
          "Location",
          "Phone",
          "Email",
          "Website",
          "Facebook",
          "Instagram",
          "TikTok",
          "Twitter",
          "LinkedIn",
          "Priority",
          "Success Chance",
          "Status",
          "Agent",
          "Date Added",
        ],
      },
      agents: {
        title: "User Management",
        subtitle: "Create and manage user accounts",
        addAgent: "Add User",
        noAgents: "No users yet",
        noAgentsDesc: "Add users to the team",
        addAgentBtn: "Add User",
        tableHeaders: {
          name: "Name",
          username: "Username",
          role: "Role",
          status: "Status",
          leadsCount: "Leads Count",
          createdDate: "Created Date",
          actions: "Actions",
        },
        roles: {
          ADMIN: "Admin",
          MANAGER: "Manager",
          AGENT: "Agent",
        },
        status: {
          active: "Active",
          inactive: "Inactive",
        },
        buttons: {
          edit: "Edit",
          delete: "Delete",
          saving: "Saving...",
          save: "Save",
          cancel: "Cancel",
        },
        modalTitles: {
          add: "Add New User",
          edit: "Edit User",
        },
        formLabels: {
          fullName: "Full Name",
          username: "Username",
          password: "Password",
          passwordHint: "(leave empty if you don't want to change)",
        },
        placeholders: {
          fullName: "Ahmed Mohammed",
          username: "ahmed_mohammed",
          password: "••••••••",
        },
        messages: {
          errorLoad: "Failed to load agents",
          errorSave: "Failed to save data",
          successUpdate: "Agent updated",
          successCreate: "Agent created",
          errorGeneric: "An error occurred",
          successDelete: "Agent deleted",
          errorDelete: "Failed to delete agent",
          errorStatus: "Failed to update status",
          confirmDelete: "Are you sure you want to delete",
        },
      },
      workspaces: {
        searchPlaceholder: "Search workspaces...",
        totalWorkspaces: "Total Workspaces",
        newWorkspace: "New Workspace",
        activeWorkspace: "Active Workspace",
        statusActive: "Active",
        statusPaused: "Paused",
        noDescription: "No additional details available for this workspace.",
        leadsCount: "Potential Leads",
        dailyLimit: "Daily Limit",
        viewDetails: "View Workspace Details",
        editSettings: "Settings",
        pauseWorkspace: "Pause",
        activateWorkspace: "Activate",
        modalTitleNew: "New Workspace",
        modalTitleEdit: "Edit Workspace Data",
        modalSubtitle: "Business Management",
        tabGeneral: "General",
        tabClient: "Client Account",
        tabSettings: "Settings",
        businessName: "Business Name",
        businessNamePlaceholder: "Example: Real Estate Company - Riyadh Branch",
        businessDescription: "Business Description",
        businessDescriptionPlaceholder: "Describe the client's activities and services...",
        businessGoal: "Business Goal",
        businessGoalPlaceholder: "Example: Convert leads to sales",
        tone: "Expected Tone",
        tonePlaceholder: "Example: formal, friendly, practical",
        clientDataDescription: "Initial login data for the client account in this workspace.",
        clientName: "User Name",
        clientNamePlaceholder: "Example: Ahmed Al-Salmi",
        clientUsername: "Login Name",
        clientUsernamePlaceholder: "Example: ahmed.salmi",
        clientPassword: "Temporary Password",
        clientPasswordPlaceholder: "••••••••",
        clientEditNote: "To edit login data after creation, use the client's dashboard for this workspace later.",
        adminAccountTitle: "Admin Account",
        adminUsername: "Admin Username",
        adminUsernamePlaceholder: "Example: admin.username",
        adminPassword: "Admin Password",
        adminPasswordPlaceholder: "••••••••",
        agentAccountTitle: "Agent Account",
        agentUsername: "Agent Username",
        agentUsernamePlaceholder: "Example: agent.username",
        agentPassword: "Agent Password",
        agentPasswordPlaceholder: "••••••••",
        dailyLimitLabel: "Daily Message Limit",
        brandingColor: "Brand Color",
        cancel: "Cancel",
        saveChanges: "Save Changes",
        createWorkspace: "Create Workspace Now",
        successUpdate: "Data updated successfully",
        successCreate: "Workspace created successfully",
        errorSave: "Error saving data",
        successActivate: "Workspace activated",
        successPause: "Workspace paused temporarily",
        errorStatus: "Failed to update status",
      },
      whatsapp: {
        title: "WhatsApp Management",
        subtitle: "Manage WhatsApp channels and conversations",
        loading: "Initializing admin panel...",
        connecting: "Initializing connection...",
        connectionFailed: "Connection failed — make sure the server is running",
        disconnectConfirm: "Disconnecting the channel will stop receiving messages immediately. Are you sure?",
        disconnected: "Disconnected",
        syncing: "Syncing...",
        syncSuccess: "Synced!",
        syncFailed: "Sync failed",
        assignSuccess: "Assigned",
        assignFailed: "Assignment failed",
        logoutSuccess: "Connection disconnected",
        logoutFailed: "Error during disconnection",
        status: {
          CONNECTED: "Connected",
          CONNECTING: "Connecting...",
          DISCONNECTED: "Disconnected",
          QR_READY: "QR Code Ready",
        },
        qrInstructions: "Scan the code with WhatsApp",
        qrNote: "The QR code will expire in 45 seconds",
        chats: "Chats",
        unassigned: "Unassigned",
        conversation: "Conversation",
        unread: "Unread",
        metrics: {
          totalChats: "Total Chats",
          activeChats: "Active Chats",
          unassignedChats: "Unassigned Chats",
          totalMessages: "Total Messages",
        },
        buttons: {
          connect: "Connect",
          disconnect: "Disconnect",
          sync: "Sync",
          refresh: "Refresh",
        },
        noChats: "No conversations yet",
        noChatsDesc: "Conversations will appear here when customers message you",
        selectChat: "Select a conversation to view messages",
        assignTo: "Assign to",
        assign: "Assign",
        noAgents: "No agents available",
        errorLoad: "Failed to load data",
        errorConnection: "Connection error",
      },
    },
    whatsapp: {
      header: "WhatsApp Pulse",
      emptyState: "Select a conversation from the left to start. AI responds on your behalf automatically.",
      qrError: "Error loading QR code",
      qrSteps: "Scan the QR code using WhatsApp on your phone",
      qrButton: "Reload QR Code",
      sidebarSearch: "Search conversations...",
      sidebarEmpty: "No conversations",
      timeFormat: "HH:mm",
      customerLabel: "WhatsApp Customer",
      loading: "Loading...",
      noMessages: "Start by sending a message or wait for customer messages.",
      loadMore: "↑ Scroll up to load older messages",
      voiceMessage: "Voice message 🎙️",
      image: "Image 🖼️",
      video: "Video 📹",
      attachedDoc: "Attached document",
      typeMessage: "Type a message...",
    },
    leads: {
      generate: {
        title: "Lead Generation",
        subtitle: "Use AI to find the best opportunities",
        locationLabel: "Geographic Location",
        locationPlaceholder: "Example: Riyadh, Dubai, or Arab World",
        countLabel: "Number of Leads Required",
        industriesLabel: "Target Sectors",
        selectedCount: "selected",
        industriesPlaceholder: "Choose sectors...",
        servicesLabel: "Offered Services",
        servicesPlaceholder: "Choose services you want to offer...",
        keywordsLabel: "Additional Keywords (Optional)",
        keywordsPlaceholder: "Example: startups, small projects, need redesign...",
        instructionsLabel: "Custom Instructions (Optional)",
        instructionsPlaceholder: "Add any extra guidance for the lead search, e.g. specific company type or tone...",
        generateButton: "Generate New Leads Now",
        generatingButton: "AI is finding the best opportunities...",
        resultsTitle: "Search Results",
        resultsCount: "lead",
        errorSelectIndustry: "Please select at least one sector",
        errorSelectService: "Please select at least one service",
        errorGeneration: "Error generating leads",
        errorConnection: "Connection error. Please check your internet connection.",
        successMessage: "Successfully generated {count} potential leads! 🎉",
        progressMessages: [
          "Creating smart search queries...",
          "AI is analyzing markets...",
          "Evaluating success opportunities for each company...",
          "Writing analyses and messages in Arabic...",
          "Sorting leads by priority...",
        ],
        successProgress: "✅ Leads generated successfully!",
        industries: [
          "E-commerce",
          "Real Estate",
          "Healthcare",
          "Education",
          "Restaurants & Cafes",
          "Law Firms",
          "Tourism & Travel",
          "Automotive",
          "Construction & Contracting",
          "Retail",
          "Fitness & Sports",
          "Beauty & Personal Care",
          "Technology & Software",
          "Financial Services",
          "Insurance",
          "Food & Beverages",
          "Clothing & Fashion",
          "Furniture & Decor",
          "Agriculture",
          "Energy & Environment",
        ],
        services: [
          "Search Engine Optimization (SEO)",
          "Google Ads",
          "Social Media Marketing",
          "Facebook & Instagram Ads",
          "TikTok Ads",
          "Website Design & Development",
          "Content Marketing",
          "Email Marketing",
          "Video Production",
          "Branding & Identity",
          "Performance Marketing",
          "Online Reputation Management",
        ],
      },
    },
  },
};

// NOTE: تمت مراجعة جميع الترجمات العربية لضمان الجودة والوضوح والسياق المهني في واجهة المستخدم.
